/**
 * Four-segment onboarding progress (BWC-4791).
 * @param {{ activeStep: number }} props 1-based active step index
 */
function StepProgress({ activeStep = 1 }) {
  return (
    <div
      className="onboarding-progress"
      role="progressbar"
      aria-valuemin={1}
      aria-valuemax={4}
      aria-valuenow={activeStep}
      aria-label={`Step ${activeStep} of 4`}
    >
      {[1, 2, 3, 4].map((step) => {
        let stateClass = '';
        if (step < activeStep) {
          stateClass = 'is-complete';
        } else if (step === activeStep) {
          stateClass = 'is-active';
        }
        return (
          <span
            key={step}
            className={`onboarding-progress-segment ${stateClass}`.trim()}
          />
        );
      })}
    </div>
  );
}

export default StepProgress;
